import React from "react";

import { Button, ButtonProps, Icon, IconGroup, SemanticCOLORS } from "semantic-ui-react";
export type EditMode = "ADD" | "APPROVE" | "DELETE" | "DUPLICATE" | "SELECT";

type ButtonModeProps = {
  id?: string;
  currentMode: EditMode;
  disabled?: boolean;
  mode: EditMode;
  onChangeEditMode: (event: React.MouseEvent<HTMLButtonElement>, data: ButtonProps) => void;
};

const getModeColor = (mode: EditMode): SemanticCOLORS => {
  switch (mode) {
    case "ADD": {
      return "green";
    }
    case "APPROVE": {
      return "orange";
    }
    case "DELETE": {
      return "red";
    }
    case "DUPLICATE": {
      return "yellow";
    }
    case "SELECT": {
      return "blue";
    }

    default: {
      return "grey";
    }
  }
};

const ModeIcon = ({ mode }: { mode: EditMode }) => {
  switch (mode) {
    case "ADD": {
      return (
        <IconGroup>
          <Icon name="clock" />
          <Icon name="add" corner />
        </IconGroup>
      );
    }
    case "APPROVE": {
      return (
        <IconGroup>
          <Icon name="file alternate outline" />
          <Icon name="check" corner />
        </IconGroup>
      );
    }
    case "DELETE": {
      return <Icon name="delete calendar" />;
    }
    case "DUPLICATE": {
      return <Icon name="copy outline" />;
    }
    case "SELECT": {
      return <Icon name="mouse pointer" />;
    }

    default: {
      const e: never = mode;

      console.warn("e:", e);

      return <Icon name="delete" />;
    }
  }
};

const ButtonMode = (props: ButtonModeProps) => {
  const isActive = props.mode === props.currentMode;
  const modeColor = getModeColor(props.mode);

  return (
    <Button
      id={props.id ?? `ButtonMode-Button-${props.mode}`}
      style={{
        minWidth: "5.15rem",
        paddingLeft: "0.2rem",
        paddingRight: "0.1rem",
      }}
      basic={!isActive}
      color={isActive ? modeColor : "grey"}
      disabled={props.disabled}
      name={props.mode}
      size="tiny"
      type="button"
      icon
      onClick={props.onChangeEditMode}
    >
      <ModeIcon mode={props.mode} />
      <label style={{ marginLeft: "2px" }}>{props.mode}</label>
    </Button>
  );
};

export default ButtonMode;
